Vue.component('app-store-checkout', {

    props: ['cartItems', 'cartHasPhysicalProduct', 'cartTotalQuantity', 'cartTotalDiscountedPrice', 'shippingMethods', 'addresses', 'countries', 'provinces', 'user', 'donations', 'scriptendpoint'],

    /*
     * Bootstrap the component. Load the initial data.
     */
    ready: function () {

      
        window.addEventListener("message", (event) => {
            if (typeof event.data == 'string') {
                try {
                    eval(event.data);
                    setTimeout(() => {
                        this.forms.checkout.busy = false;
                        swal.close()
                    }, 2000)
                }
                catch(e){
                    this.forms.checkout.busy = false;
                    // swal.close()
                }
            }
        });

        this.generateOptionTitlesForAddresses();
    },

    /*
     * Initial state of the component's data.
     */
    data: function () {
        return {
            redirect_form_key:[],
            instantlink: '',
            payment_token: '',
            instant_eft_success: false,
            forms: {
                checkout: $.extend(true, new AppForm({
                    busy: false,
                    shippingMethod: this.shippingMethods[0],
                    deliveryAddress: this.getDefaultDeliveryAddress(),
                    paymentOption: null,
                    free: false,
                    card: null,
                    terms: false,
                    donations: 1
                }), App.forms.checkout)
            },
            addingNewCard: false,
            newcard: {
                number: '',
                holder: '',
                exp_month: '',
                exp_year: '',
                cvv: '',
                return: '',
                errors: []
            },
            threeDs: {
                url: '',
                connector: '',
                MD: '',
                TermUrl: '',
                PaReq: ''
            },
            readyForThreeDs: false,
            checkoutId: null,
            entityId: null
        };
    },

    computed: {
        total: function () {
            var that = this;
            var total = that.cartTotalDiscountedPrice;
            if (that.cartHasPhysicalProduct)
                total += parseFloat(this.forms.checkout.shippingMethod.price);

            if (this.getDonations()) {
                total += this.getDonations();
            }
            
            return total;
        },

        free: function () {
          if (this.total <= 0){
              this.forms.checkout.free = true
          }
          return this.forms.checkout.free
        },

        checkFreePayment: function () {
          if (this.forms.checkout.free === true){
              this.forms.checkout.paymentOption = 'eft'
          }
            return this.forms.checkout.paymentOption
        }
    },

    mounted() {
        this.loadPeachScript();
    },

    methods: {

          loadPeachScript: function() {
            return new Promise((resolve, reject) => {
                if (window.Checkout) {
                    return resolve();
                }

                const script = document.createElement("script");
                script.src = this.scriptendpoint;
                script.onload = resolve;
                script.onerror = reject;

                console.log(this.scriptendpoint);

                document.head.appendChild(script);
            });
        },

        closeModal() {
            $("#checkout_model").modal("hide");
            this.checkoutId = null;
        },

        handleSuccess(event) {
            this.closeModal();
        },


        popEft() {

            if (!this.validate()) {
                return;
            }

            this.process();
            this.forms.checkout.busy = true;
            this.getEftLink();
        },

           getEftLink: async function() {
            this.processPayment();
            this.showModal = true;
            await this.loadPeachScript();

            let data = {
                store: true,
                total: this.total
            };

            this.$http
                .post("/instant-eft", data)
                .then(async response => {
                    const res = response.data;

                    if (!res.checkoutId || !res.entityId) {
                        return;
                    }

                    this.checkoutId = res.checkoutId;
                    this.entityId = res.entityId;

                    await this.$nextTick();

                    $("#checkout_model").modal("show");

                    setTimeout(() => {
                        swal.close();
                        this.initCheckout();
                    }, 300);
                })
                .catch(error => {
                     let message = "Unable to process your request!";

    if (error.status == 422) {
        message = error.data.message;
    }

    swal({
        type: "warning",
        title: "Error",
        text: message,
        showConfirmButton: true
    });
                    this.forms.checkout.busy = false;
                    return;
                });
        },

        initCheckout: function() {
            const checkout = window.Checkout.initiate({
                key: this.entityId,
                checkoutId: this.checkoutId,

                options: {
                    theme: {
                        brand: {
                            primary: "#ff0000"
                        },
                        cards: {
                            background: "#00ff00",
                            backgroundHover: "#F3F3F4"
                        }
                    },

                    paymentMethods: {
                        include: [
                            "CARD",
                            "OZOW",
                            "MASTERPASS",
                            "MOBICRED",
                            "PAYFLEX",
                            "1FORYOU",
                            "PAYSHAP",
                            "PAYBYBANK",
                            "CAPITECPAY",
                            "NEDBANKDIRECTEFT",
                            "ABSAEFT",
                            "PEACHEFT"
                        ]
                    },

                    ordering: {
                        OZOW: 1,
                        CARD: 2,
                        MASTERPASS: 3,
                        MOBICRED: 4,
                        PAYFLEX: 5,
                        "1FORYOU": 6,
                        PAYSHAP: 7,
                        PAYBYBANK: 8,
                        CAPITECPAY: 9,
                        NEDBANKDIRECTEFT: 10,
                        ABSAEFT: 11,
                        PEACHEFT: 12
                    }
                },

                events: {
                    onCompleted: event => {
                        const resultCode = event.result.code || "";

                        const message =
                            event.result.description ||
                            "Payment response received";

                        const isSuccess = /^(000\.000\.|000\.100\.1|000\.[36]|000\.400\.[1][12]0)/.test(
                            resultCode
                        );

                        if (isSuccess) {
                            swal({
                                type: "success",
                                title: "Payment Successful",
                                text: message,
                                showConfirmButton: true
                            });
                            this.instant_eft_success = true;
                            this.sendCheckout();
                        } else {
                            swal({
                                type: "error",
                                title: "Payment Failed",
                                text: message,
                                showConfirmButton: true
                            });

                            this.forms.checkout.busy = false;
                            return;
                        }
                    },
                    onCancelled: event => {
                        swal({
                            type: "error",
                            title: "Error",
                            text: "Your Payment has Cancelled, please try again"
                        });
                        swal.close();
                        this.forms.checkout.busy = false;
                    },
                    onExpired: event => {
                        swal({
                            type: "error",
                            title: "Error",
                            text:
                                "Your Payment has Session Expired, please try again"
                        });
                        swal.close();
                        this.forms.checkout.busy = false;
                    }
                }
            });

            checkout.render("#payment-form");
        },

        addCard() {
            this.newcard.return = `/store/checkout?threeDs=yes`;

            this.processPayment();            

            this.$http.post('/account/billing', this.newcard)
                .then(response => {
                    if(response.data.redirect === undefined || response.data.redirect === null) {
                        this.saveCard(response.data.id);
                        this.addingNewCard = false;
                        swal.close();
                    } else {
                        this.threeDs.url = response.data.redirect.url;
                        for (var i = response.data.redirect.parameters.length - 1; i >= 0; i--) {
                            this.redirect_form_key.push({
									form_key: response.data.redirect.parameters[i].name,
									form_value: response.data.redirect.parameters[i].value
							});
                            this.threeDs[response.data.redirect.parameters[i].name] = response.data.redirect.parameters[i].value;
                        }
                        this.readyForThreeDs = true;
                        swal.close();
                    }                    
                })
                .catch(errors => {
                    this.newcard.errors = errors.data;
                    swal.close();
                });
        },

        /**
         * Save User Card
         */
        saveCard(id) {
            this.process();
            this.$http.post('/account/billing/card', { id: id })
                .then(response => {
                    this.user.cards.push(response.data.card)
                    this.forms.checkout.card = response.data.card.id;
                    swal.close()
                })
                .catch(errors => {
                    swal.close();
                    if(errors.number) {
                        swal({
                            type: 'error',
                            title: 'Whoops',
                            text: errors.number
                        })
                    }
                })
        },

        generateOptionTitlesForAddresses: function () {
            var that = this;
            _.forEach(this.addresses, function (address, key) {
                var selectOptionTitle = address.type.toUpperCase();
                if (address.line_one)
                    selectOptionTitle += " - " + address.line_one;
                if (address.line_two)
                    selectOptionTitle += ", " + address.line_two;
                if (address.city)
                    selectOptionTitle += ", " + address.city;
                if (address.area_code)
                    selectOptionTitle += ", " + address.area_code;
                if (address.province)
                    selectOptionTitle += ", " + that.provinces[address.province];
                if (address.country)
                    selectOptionTitle += ", " + that.countries[address.country];

                Vue.set(address, 'selectOptionTitle', selectOptionTitle);
            });
        },

        getDefaultDeliveryAddress: function () {
            if (this.addresses.length == 0)
                return 0;

            var primaryAddress = false;
            _.forEach(this.addresses, function (address, key) {
                if (address.primary) {
                    primaryAddress = address;
                    return false;
                }
            });

            if (primaryAddress)
                return primaryAddress;

            return this.addresses[0];
        },
        
        calculateTotalQuantity: function () {
            console.log(this.cart);
            var totalQty = 0;
            _.forEach(this.cart, function (cartItem, key) {
                totalQty += cartItem.quantity;
            });
            return totalQty;
        },

        checkout: function () {
            this.forms.checkout.errors.forget();
            this.forms.checkout.busy = true;
            //this.process();
            this.sendCheckout();
        },
        processPayment: function() {
            swal({
                type: "warning",
                title: "Payment Processing",
                text: "Please wait while we are processing your payment.Do not Refresh page or close browser"
            })
        },


        beginCheckout: function () {

            window.dataLayer = window.dataLayer || [];

            var items = [];


            _.forEach(this.cart, function (cartItem, key) {
                items.push({
                    item_id: String(cartItem.id),
                    item_name: cartItem.title,
                    item_category: "Webinar On Demand",
                    price: parseFloat(parseFloat(cartItem.price).toFixed(2)),
                    quantity:  cartItem.qty
               });
            });
          

            window.dataLayer.push({ ecommerce: null });

            window.dataLayer.push({
                event: "begin_checkout",
                ecommerce: {
                    value: parseFloat(parseFloat(this.total).toFixed(2)),
                    currency: "ZAR",
                    items: items
                },
                email: this.user.email || undefined,
                cell: this.user.cell || undefined,
            });
        },

        sendTransactions: function (invoice) {
            
            window.dataLayer = window.dataLayer || [];

            var items = [];

            if (invoice.items && invoice.items.length > 0) {
                invoice.items.forEach(function (item) {
                    items.push({
                        item_id: String(item.item_id),
                        item_name: item.name,
                        item_category: "Webinars on demand",
                        price: parseFloat(parseFloat(item.price).toFixed(2)),
                        quantity: item.quantity
                    });
                });
            }

            window.dataLayer.push({ ecommerce: null });

            window.dataLayer.push({
                event: "purchase",
                ecommerce: {
                    transaction_id: invoice.reference,
                    value: parseFloat(parseFloat(invoice.total).toFixed(2)),
                    currency: "ZAR",
                    items: items
                },
                payment_method: this.getPaymentMethod() || undefined,
                payment_status: invoice.paid == 1 ?  "successful" : "failed",
                email: this.user.email || undefined,
                cell: this.user.cell || undefined,
            });
        },

        getPaymentMethod:function(){
            if(this.forms.checkout.paymentOption == 'cc'){
              return  'Credit Card';
            }  
            
            if(this.forms.checkout.paymentOption == 'eft'){
              return  'Instant EFT';
            }  


            return "Purchase Order";
        },

        sendCheckout: function () {

            if (this.forms.checkout.free === false){
                if(this.forms.checkout.paymentOption == 'eft' && this.instant_eft_success == false) {
                    this.forms.checkout.busy = true;
                    return;
                }
            }

            var payload = {
                terms: this.forms.checkout.terms,
                free: this.forms.checkout.free,
                card: this.forms.checkout.card,
                paymentOption: this.forms.checkout.paymentOption,
                shippingMethodId: this.forms.checkout.shippingMethod.id,
                deliveryAddressId: this.forms.checkout.deliveryAddress.id,
                donations: this.getDonations(),
            };

            this.processPayment();
            this.beginCheckout();

            this.$http.post('/store/checkout', payload)
                .success(function (response) {
                    this.forms.checkout.busy = false;
                    swal.close();
                    if (response.invoice !== undefined) {
                        this.sendTransactions(response.invoice);
                    }
                    window.location = '/dashboard/products';
                })
                .error((errors) => {
                    this.forms.checkout.busy = false;

                    if(errors.errors && errors.errors.card) {
                        swal({
                            type: 'error',
                            title: 'Whoops',
                            text: errors.errors.card
                        })
                    } else {
                        // swal.close();
                    }

                    this.forms.checkout.errors.set(errors);
                });
        },

        cancelPayment: function () {
            this.forms.checkout.busy = false;
        },

  
        startListener: function () {
            var pusher = new Pusher('5e9e56a5a0ebaf5484b0', {
              cluster: 'mt1'
            });

            var channel = pusher.subscribe('instantefts');

            channel.bind("App\\Events\\InstantEftNotificationReceived", (data) => {
              if(this.payment_token == data.payment_key) {
                  console.log(data)
                  if(data.success === true) {
                    this.process();
                    this.instant_eft_success = true;
                    this.sendCheckout();
                } else {
                    this.cancelPayment();
                    swal({
                        type: 'error',
                        title: 'Error',
                        text: "Your Payment has failed, please try again"
                    })
                }
              }
            });

        },

        process: function () {
            swal({
                title: "",
                text: '<i id="busy" class="fa fa-spinner fa-pulse" style="font-size: 8em; color: #000066;"></i>',
                html: true,
                allowEscapeKey: false,
                allowOutsideClick: false,
                showCancelButton: false,
                showConfirmButton: false,
                closeOnCancel: false,
                customClass: 'no-bg'
            });
        },

        /*
         * Calculate the donation
         */
        getDonations: function() {

            var total = 0;
            if(this.forms.checkout.donations) {
                total = this.donations;
            }
            return total;
        },
         validate: function() {
            if (!this.forms.checkout.terms) {
                swal({
                    type: "warning",
                    title: "Error",
                    text:
                        "Please accept term's and condition to process booking!"
                });
                this.forms.checkout.busy = false;
                return false;
            }

            if (this.forms.checkout.donations) {
                if (this.id_number == "") {
                    swal({
                        type: "warning",
                        title: "Error",
                        text: "Please enter id number"
                    });
                    this.forms.checkout.busy = false;
                    return false;
                }

                if (this.id_type == "") {
                    swal({
                        type: "warning",
                        title: "Error",
                        text: "Please enter valid id type"
                    });
                    this.forms.checkout.busy = false;
                    return false;
                }

                if (this.country_of_issue == "") {
                    swal({
                        type: "warning",
                        title: "Error",
                        text: "Please select valid country"
                    });
                    this.forms.checkout.busy = false;
                    return false;
                }

                if (this.incometax_reference_number == "") {
                    swal({
                        type: "warning",
                        title: "Error",
                        text: "Please select valid income tax reference number!"
                    });
                    this.forms.checkout.busy = false;
                    return false;
                }

                if (this.company_name == "") {
                    swal({
                        type: "warning",
                        title: "Error",
                        text: "Please enter valid company name!"
                    });
                    this.forms.checkout.busy = false;
                    return false;
                }

                if (this.company_registrations_number == "") {
                    swal({
                        type: "warning",
                        title: "Error",
                        text: "Please enter company registration number"
                    });
                    this.forms.checkout.busy = false;
                    return false;
                }

                if (this.date_of_birth == "") {
                    swal({
                        type: "warning",
                        title: "Error",
                        text: "Please select date of birth"
                    });
                    this.forms.checkout.busy = false;
                    return false;
                }

                if (this.postal_address == "") {
                    swal({
                        type: "warning",
                        title: "Error",
                        text: "Please enter valid postal address"
                    });
                    this.forms.checkout.busy = false;
                    return false;
                }
                if (this.post_code == "") {
                    swal({
                        type: "warning",
                        title: "Error",
                        text: "Please enter valid postal code"
                    });
                    this.forms.checkout.busy = false;
                    return false;
                }
            }

            return true;
        }
    }
})
;



// WEBPACK FOOTER //
// ./resources/assets/js/store/checkout.js